import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';

const SHAPES = ['square', 'circle', 'triangle'];

export default function ShapeEditor({ isOpen, onClose, onSave }) {
  const [selectedShape, setSelectedShape] = useState('square');
  const [color, setColor] = useState('#ff0000');

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-sm w-full bg-white rounded-xl shadow-xl">
          <div className="p-6">
            <Dialog.Title className="text-lg font-semibold mb-6">
              Add Shape
            </Dialog.Title>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Shape Type
                </label>
                <select
                  value={selectedShape}
                  onChange={(e) => setSelectedShape(e.target.value)}
                  className="w-full p-2 border rounded-lg"
                >
                  {SHAPES.map(shape => (
                    <option key={shape} value={shape}>
                      {shape.charAt(0).toUpperCase() + shape.slice(1)}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Color
                </label>
                <input
                  type="color"
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                  className="w-full h-10 p-1 rounded-lg"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Preview
                </label>
                <div className="w-full aspect-video bg-gray-100 rounded-lg flex items-center justify-center">
                  {selectedShape === 'triangle' ? (
                    <div className="w-20 h-20 flex items-center justify-center overflow-visible">
                      <svg width="80" height="80" viewBox="0 0 100 100">
                        <polygon 
                          points="50,10 10,90 90,90" 
                          fill={color}
                        />
                      </svg>
                    </div>
                  ) : (
                    <div
                      className="w-20 h-20"
                      style={{
                        backgroundColor: color,
                        borderRadius: selectedShape === 'circle' ? '50%' : '0',
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-700 hover:text-gray-900"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onSave({ shape: selectedShape, style: { fill: color } });
                  onClose();
                }}
                className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800"
              >
                Apply
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}